"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _functionalButton = require("@widget/functional-button");

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _useDebouncedEffect = require("use-debounced-effect");

var _reduxForm = require("redux-form");

var _MethodFactory = _interopRequireDefault(require("./MethodFactory"));

var _PayoutMethodsFactory = _interopRequireDefault(require("./PayoutMethodsFactory"));

var _useGetSelectedMethod = _interopRequireDefault(require("../hooks/useGetSelectedMethod"));

var _useGetSelectedAccount = _interopRequireDefault(require("../hooks/useGetSelectedAccount"));

var _useGetAccountsFromShop = _interopRequireDefault(require("../hooks/useGetAccountsFromShop"));

var _useGetPayoutMethodsFromSelectedShop = _interopRequireDefault(require("../hooks/useGetPayoutMethodsFromSelectedShop"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var DEBIT_DIRECTION = 'debit';
var CREDIT_DIRECTION = 'credit';

var Option = function Option(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/_react["default"].createElement("span", {
    "data-locator": "method.select.value",
    className: _defaultModule["default"]['method']
  }, item['icon'] && /*#__PURE__*/_react["default"].createElement("span", {
    className: _defaultModule["default"]['icon']
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: _defaultModule["default"]['image'],
    src: require('./icons/' + item['icon']),
    alt: ''
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: _defaultModule["default"]['method__name'],
    "data-locator": "Payout.method.title"
  }, item['displayName'] || item['name']));
};

function amountDebitValidate(values) {
  if (!values['amount-debit']) {
    return false;
  } else if (!/^\d+(\.\d{1,2})?$/.test(values['amount-debit'])) {
    // eslint-disable-next-line
    return false;
  } else if (Number(values['amount-debit']) <= 0) {
    return false;
  } else if (Number(values['amount-debit']) > Number(values['account']['available'])) {
    return false;
  }

  return true;
}

function amountCreditValidate(values) {
  if (!values['amount-credit']) {
    return false;
  } else if (!/^(\d+)(\.\d{1,2})?$/.test(values['amount-credit'])) {
    // eslint-disable-next-line
    return false;
  } else if (Number(values['amount-credit']) <= 0) {
    return false;
  }

  return true;
}

function ModifyForm(_ref2) {
  var shops = _ref2.shops,
      handleSubmit = _ref2.handleSubmit,
      disabled = _ref2.disabled,
      valid = _ref2.valid,
      pristine = _ref2.pristine;

  try {
    var handleChangeFlag = function handleChangeFlag(direction) {
      setDirection(direction);
    };

    var dispatch = (0, _reactRedux.useDispatch)();

    var _useState = (0, _react.useState)(0),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        commission = _useState2[0],
        setCommission = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
        hasChanged = _useState4[0],
        setChanged = _useState4[1];

    var _useState5 = (0, _react.useState)(null),
        _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
        direction = _useState6[0],
        setDirection = _useState6[1];

    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInSubmitProcess);
    var formValues = (0, _reactRedux.useSelector)((0, _reduxForm.getFormValues)('payout-create'));
    var payoutMethods = (0, _useGetPayoutMethodsFromSelectedShop["default"])(formValues['shop']);
    var selectedPayoutMethod = (0, _useGetSelectedMethod["default"])(payoutMethods);
    var accounts = (0, _useGetAccountsFromShop["default"])(formValues['shop']);
    var selectAccount = (0, _useGetSelectedAccount["default"])(accounts);
    (0, _react.useEffect)(function () {
      setDirection(null);
      dispatch((0, _reduxForm.change)('payout-create', 'shop', formValues['shop']));
      dispatch((0, _reduxForm.change)('payout-create', 'account', null));
      dispatch((0, _reduxForm.change)('payout-create', 'method', null));
      dispatch((0, _reduxForm.change)('payout-create', 'destination', null));
      dispatch((0, _reduxForm.change)('payout-create', 'amount-debit', null));
      dispatch((0, _reduxForm.change)('payout-create', 'amount-credit', null));
      dispatch((0, _reduxForm.change)('payout-create', 'amount-commission', 0));
    }, [formValues['shop']]);
    (0, _react.useEffect)(function () {
      dispatch((0, _reduxForm.change)('payout-create', 'method', selectedPayoutMethod));
      dispatch((0, _reduxForm.change)('payout-create', 'destination', null));
      dispatch((0, _reduxForm.change)('payout-create', 'amount-debit', null));
      dispatch((0, _reduxForm.change)('payout-create', 'amount-credit', null));
      dispatch((0, _reduxForm.change)('payout-create', 'amount-commission', 0));
    }, [selectedPayoutMethod]);
    (0, _react.useEffect)(function () {
      dispatch((0, _reduxForm.change)('payout-create', 'account', selectAccount));
    }, [selectAccount]);
    (0, _react.useEffect)(function () {
      if (formValues['shop'] && formValues['shop']['requiresRecipientFullName']) {
        dispatch((0, _reduxForm.touch)('payout-create', 'recipientFullName'));
      }
    }, [formValues['shop']]);
    (0, _react.useEffect)(function () {
      function init() {
        return _init.apply(this, arguments);
      }

      function _init() {
        _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
          var result;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (hasChanged) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return", void 0);

                case 2:
                  if (formValues['shop']['isShowCommissionCalculation']) {
                    _context.next = 5;
                    break;
                  }

                  setChanged(false);
                  return _context.abrupt("return", void 0);

                case 5:
                  if (formValues['destination']) {
                    _context.next = 7;
                    break;
                  }

                  return _context.abrupt("return", void 0);

                case 7:
                  if (!(direction === DEBIT_DIRECTION)) {
                    _context.next = 14;
                    break;
                  }

                  if (amountDebitValidate(formValues)) {
                    _context.next = 12;
                    break;
                  }

                  dispatch((0, _reduxForm.blur)('payout-create', 'amount-debit', formValues['amount-debit'], true));
                  setChanged(false);
                  return _context.abrupt("return", void 0);

                case 12:
                  _context.next = 19;
                  break;

                case 14:
                  if (!(direction === CREDIT_DIRECTION)) {
                    _context.next = 19;
                    break;
                  }

                  if (amountCreditValidate(formValues)) {
                    _context.next = 19;
                    break;
                  }

                  dispatch((0, _reduxForm.blur)('payout-create', 'amount-credit', formValues['amount-credit'], true));
                  setChanged(false);
                  return _context.abrupt("return", void 0);

                case 19:
                  _context.prev = 19;
                  setCommission(0);
                  _context.next = 23;
                  return dispatch((0, _functionalButton.getCommission)(formValues, direction === DEBIT_DIRECTION));

                case 23:
                  result = _context.sent;

                  if (result) {
                    if (direction === DEBIT_DIRECTION) {
                      setCommission(result['amountCommission']);
                      dispatch((0, _reduxForm.change)('payout-create', 'amount-credit', String(result['amountCredit'])));
                      dispatch((0, _reduxForm.touch)('payout-create', 'amount-credit'));
                    } else if (direction === CREDIT_DIRECTION) {
                      setCommission(result['amountCommission']);
                      dispatch((0, _reduxForm.change)('payout-create', 'amount-debit', String(result['amountDebit'])));
                      dispatch((0, _reduxForm.touch)('payout-create', 'amount-debit'));
                    }
                  }

                  _context.next = 30;
                  break;

                case 27:
                  _context.prev = 27;
                  _context.t0 = _context["catch"](19);
                  console.log('credit error', _context.t0);

                case 30:
                  setChanged(false);

                case 31:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[19, 27]]);
        }));
        return _init.apply(this, arguments);
      }

      init();
    }, [hasChanged, direction]);
    (0, _useDebouncedEffect.useDebouncedEffect)(function () {
      if (direction !== DEBIT_DIRECTION) {
        return void 0;
      }

      setChanged(true);
    }, 800, [formValues['amount-debit'], formValues['account']]);
    (0, _useDebouncedEffect.useDebouncedEffect)(function () {
      if (direction !== CREDIT_DIRECTION) {
        return void 0;
      }

      setChanged(true);
    }, 800, [formValues['amount-credit'], formValues['account']]);
    return /*#__PURE__*/_react["default"].createElement("form", {
      className: _defaultModule["default"]['dialog'],
      "data-locator": "Payout.dialog",
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement("article", {
      className: _defaultModule["default"]['dialog__content'],
      "data-locator": "Payout.dialog.content"
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: _defaultModule["default"]['dialog__section']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      label: "\u041C\u0430\u0433\u0430\u0437\u0438\u043D",
      name: "shop",
      optionKey: "id",
      optionValue: "name",
      clearable: false,
      simple: false,
      options: shops,
      disabled: disabled || inProcess,
      required: true
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      label: "\u0421\u043F\u043E\u0441\u043E\u0431 \u0432\u044B\u0432\u043E\u0434\u0430",
      name: "method",
      useKey: false,
      clearable: false,
      optionsValue: "payment",
      valueTemplate: function valueTemplate(item) {
        return /*#__PURE__*/_react["default"].createElement(Option, {
          item: item
        });
      },
      optionTemplate: function optionTemplate(item) {
        return /*#__PURE__*/_react["default"].createElement(Option, {
          item: item
        });
      },
      options: payoutMethods,
      disabled: disabled || inProcess || !formValues['shop'],
      required: true
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_MethodFactory["default"], {
      code: selectedPayoutMethod ? selectedPayoutMethod['name'] : null,
      disabled: disabled || inProcess
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_PayoutMethodsFactory["default"], {
      code: selectedPayoutMethod ? selectedPayoutMethod['name'] : null,
      disabled: disabled || inProcess
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: formValues['shop'] && formValues['shop']['requiresRecipientFullName'] ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\u0424\u0418\u041E \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F", /*#__PURE__*/_react["default"].createElement("span", {
        className: _defaultModule["default"]['field-hint']
      }, "* \u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E, \u0435\u0441\u043B\u0438 \u0432\u044B \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442\u0435 \u0447\u0435\u0440\u0435\u0437 \u0422-\u0411\u0430\u043D\u043A")) : 'ФИО получателя',
      name: "recipientFullName",
      maxLength: 100,
      disabled: disabled || inProcess,
      required: Boolean(formValues['shop'] && formValues['shop']['requiresRecipientFullName'])
    }))), formValues['shop'] && !formValues['shop']['isShowCommissionCalculation'] && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['dialog__disclaimer']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment'
    }, "\u041E\u043A\u043E\u043D\u0447\u0430\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0441\u044F \u0432\xA0\u0432\u044B\u043F\u0438\u0441\u043A\u0435"))), /*#__PURE__*/_react["default"].createElement("section", {
      className: _defaultModule["default"]['dialog__section']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.TextareaField, {
      label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 (\u0432\u0438\u0434\u0438\u0442\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u044B)",
      name: "description",
      disabled: disabled || inProcess || !formValues['destination'],
      required: true
    }))), formValues['shop'] && !formValues['shop']['isShowCommissionCalculation'] && /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper__field']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "\u0421\u0443\u043C\u043C\u0430 \u0437\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F",
      name: "amount",
      disabled: disabled || inProcess || !formValues['destination'] || !formValues['description'],
      onChange: function onChange() {
        return handleChangeFlag(DEBIT_DIRECTION);
      },
      required: true
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper__currency']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['currency'],
      "data-locator": "payout.amount.currency"
    }, selectAccount && selectAccount['name']))))), formValues['shop'] && formValues['shop']['isShowCommissionCalculation'] && /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper__field']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "\u0421\u0443\u043C\u043C\u0430 \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F",
      name: "amount-debit",
      disabled: disabled || inProcess || !formValues['destination'] || !formValues['description'],
      onFocus: function onFocus() {
        return handleChangeFlag(DEBIT_DIRECTION);
      },
      required: true
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper__currency']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      label: "\u0412\u0430\u043B\u044E\u0442\u0430",
      placeholder: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0430\u043B\u044E\u0442\u0443",
      name: "account",
      clearable: false,
      simple: false,
      options: accounts,
      onChange: function onChange() {
        return handleChangeFlag(DEBIT_DIRECTION);
      },
      disabled: disabled || inProcess || !formValues['destination'] || !formValues['description'],
      isLoading: true,
      required: true
    }))))), formValues['shop'] && formValues['shop']['isShowCommissionCalculation'] && /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper__field']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "\u0421\u0443\u043C\u043C\u0430 \u0437\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F",
      name: "amount-credit",
      disabled: disabled || inProcess || !formValues['destination'] || !formValues['description'],
      onFocus: function onFocus() {
        return handleChangeFlag(CREDIT_DIRECTION);
      },
      required: true
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper__currency']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['currency'],
      "data-locator": "payout.amount.credit.currency"
    }, selectAccount && selectAccount['name']))))), formValues['shop'] && formValues['shop']['isShowCommissionCalculation'] && /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment'
    }, "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F: ", commission, " ", selectAccount && selectAccount['name']))))), /*#__PURE__*/_react["default"].createElement("footer", {
      className: _defaultModule["default"]['dialog__controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": "submit",
      type: "submit",
      mode: "success",
      inProcess: inProcess,
      disabled: !valid || pristine
    }, "\u0412\u044B\u0432\u0435\u0441\u0442\u0438"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['dialog__controls-note']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment'
    }, "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F, \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u0435 \u0437\u0432\u0435\u0437\u0434\u043E\u0447\u043A\u043E\u0439,", /*#__PURE__*/_react["default"].createElement("br", null), "\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F"))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = ModifyForm;
exports["default"] = _default;